import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  APP_STORE_CONFIGURATION_URL,
  APP_STORE_OAUTH_URL,
  OUTLOOK_SYNC_API_URL,
  OUTLOOK_SYNC_SUBSCRIPTION_KEY,
} from './config';
import {
  AppDirectoryService,
  EmailSyncService,
  MicrosoftAuthSyncService,
  UserSyncConfigurationService,
} from './services';

export interface OutlookSyncDataAccessConfig {
  apiUrl: string;
  subscriptionKey: string;
  appStoreOAuthUrl: string;
  appStoreConfigurationUrl: string;
}

export function provideOutlookSyncDataAccess(
  config: OutlookSyncDataAccessConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    AppDirectoryService,
    UserSyncConfigurationService,
    MicrosoftAuthSyncService,
    EmailSyncService,
    { provide: OUTLOOK_SYNC_API_URL, useValue: config.apiUrl },
    {
      provide: OUTLOOK_SYNC_SUBSCRIPTION_KEY,
      useValue: config.subscriptionKey,
    },
    { provide: APP_STORE_OAUTH_URL, useValue: config.appStoreOAuthUrl },
    {
      provide: APP_STORE_CONFIGURATION_URL,
      useValue: config.appStoreConfigurationUrl,
    },
  ]);
}
